export const Status404 = () => {
    return <>404 not found</>
}